import styles from '../Interview.module.scss'

type Props = {
  src: string
  alt: string
  text?: string | JSX.Element
  right?: boolean
  size?: 'm' | 's' | 'ss'
}

const ImageWithCaption: React.FC<Props> = ({ src, alt, text, size }) => {
  const imgClass = size ? styles[`img_${size}`] : styles.img_l

  return (
    <div className={styles.img_wrapper}>
      <img className={imgClass} src={src} alt={alt} />
      {text && (
        <>
          {typeof text === 'string'
            ? text.split('\n\n').map((line, index) => (
                <p key={index} className={styles.img_text}>
                  <span>{line}</span>
                </p>
              ))
            : text}
        </>
      )}
    </div>
  )
}

export default ImageWithCaption
